import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
`

export const TooltipContainer = styled.div`
  margin-left: 8px;
`
